module.exports = __webpack_public_path__ + "media/teams/course_preview_two-780f2f9d.png";